import React from 'react';
import { View, StyleSheet, ScrollView, Linking, Image } from 'react-native';
import { Card, Title, Paragraph, List, Divider, Button, useTheme } from 'react-native-paper';

const AboutScreen = () => {
  const theme = useTheme();
  
  // App version information
  const appInfo = {
    name: 'İlkay Kids',
    version: '1.0.0',
    developer: 'Caner Başat',
    email: 'ilkaykids@gmail.com',
    website: 'https://ilkaykids.com',
    address: 'Adnan Menderes Mahallesi, Fidanlık Sokak, Masal Park No:4 Merkez/Osmaniye',
    phone: '+90 (537) 411 56 41'
  };
  
  // Open URL
  const openURL = (url) => {
    Linking.canOpenURL(url).then(supported => {
      if (supported) {
        Linking.openURL(url);
      } else {
        //console.log("URL açılamıyor: " + url);
      }
    });
  };
  
  // Call phone number
  const callPhone = (phoneNumber) => {
    Linking.openURL(`tel:${phoneNumber.replace(/\s/g, '')}`);
  };
  
  // Send email
  const sendEmail = (email) => {
    Linking.openURL(`mailto:${email}`);
  };
  
  return (
    <ScrollView style={styles.container}>
      {/* Logo ve Uygulama Bilgisi */}
      <Card style={styles.headerCard}>
        <Card.Content style={styles.headerContent}>
          <Image
            source={require('../../../assets/logo.png')}
            style={styles.logo}
            resizeMode="contain"
          />
          <Title style={styles.appName}>{appInfo.name}</Title>
          <Paragraph style={styles.version}>Versiyon {appInfo.version}</Paragraph>
        </Card.Content>
      </Card>
      
      {/* Hakkımızda */}
      <Card style={styles.sectionCard}>
        <Card.Title titleStyle={{color: 'rgb(125, 76, 236)'}} title="Hakkımızda – İlkay Kids" />
        <Card.Content>
          <Paragraph style={styles.paragraph}>
            İlkay Kids, çocukların doyasıya eğlenebileceği, ebeveynlerin ise keyifle dinlenebileceği özel bir buluşma noktasıdır. İçerisinde yer alan güvenli ve renkli oyun parkıyla minik misafirlerimize neşe dolu anlar sunarken, kafe bölümümüzde ise ailelere sıcak bir kahve, lezzetli atıştırmalıklar ve huzurlu bir ortam sağlıyoruz.
          </Paragraph>
          <Paragraph style={styles.paragraph}>
            Amacımız; çocukların enerjisini güvenle atabileceği, ailelerin ise vakit geçirirken kendilerini evlerinde gibi hissedebileceği bir alan yaratmak.
          </Paragraph>
          <Paragraph style={styles.paragraph}>
            İlkay Kids'te eğlence ve konfor bir arada!
          </Paragraph>
          <Paragraph style={[styles.paragraph, styles.featureTitle]}>
            Uygulama Özellikleri:
          </Paragraph>
          <List.Item
            title="Çocuk Profili Yönetimi"
            description="Çocuklarınızın profillerini oluşturup yönetin"
            left={props => <List.Icon {...props} icon="account-child" />}
            onPress={null}
          />
          <Divider style={styles.divider} />
          <List.Item
            title="Oyun Parkı Ziyaret Takibi"
            description="Çocuklarınızın oyun parkı ziyaretlerini planlayın ve takip edin"
            left={props => <List.Icon {...props} icon="calendar-clock" />}
            onPress={null}
          />
          <Divider style={styles.divider} />
          <List.Item
            title="Geçmiş Ziyaretler"
            description="Geçmiş ziyaretleri ve ödemeleri görüntüleyin"
            left={props => <List.Icon {...props} icon="history" />}
            onPress={null}
          />
        </Card.Content>
      </Card>
      
      {/* İletişim Bilgileri */}
      <Card style={styles.sectionCard}>
        <Card.Title titleStyle={{color: 'rgb(125, 76, 236)'}} title="İletişim" />
        <Card.Content>
          <List.Item
            title="E-posta"
            description={appInfo.email}
            onPress={() => sendEmail(appInfo.email)}
            left={props => <List.Icon {...props} icon="email" color="rgb(125, 76, 236)" />}
          />
          <Divider style={styles.divider} />
          <List.Item
            title="Telefon"
            description={appInfo.phone}
            onPress={() => callPhone(appInfo.phone)}
            left={props => <List.Icon {...props} icon="phone" color="rgb(125, 76, 236)" />}
          />
          <Divider style={styles.divider} />
          <List.Item
            title="Adres"
            description={appInfo.address}
            onPress={() => openURL(`https://maps.google.com/?q=${encodeURIComponent(appInfo.address)}`)}
            left={props => <List.Icon {...props} icon="map-marker" color="rgb(125, 76, 236)" />}
          />
        </Card.Content>
      </Card>
      
      {/* Geliştirici Bilgileri */}
      <Card style={[styles.sectionCard, styles.lastCard]}>
        <Card.Content style={styles.footer}>
          <Paragraph style={styles.footerText}>
            {new Date().getFullYear()} {appInfo.name}. Tüm hakları saklıdır.
          </Paragraph>
          <Paragraph style={styles.footerText}>
            Geliştirici: {appInfo.developer}
          </Paragraph>
        </Card.Content>
      </Card>
    </ScrollView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: 'rgb(232, 162, 249)',
  },
  headerCard: {
    margin: 16,
    marginBottom: 8,
    elevation: 4,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  headerContent: {
    alignItems: 'center',
    paddingVertical: 24,
  },
  logo: {
    width: 120,
    height: 120,
    marginBottom: 16,
  },
  appName: {
    fontSize: 24,
    fontWeight: 'bold',
    color: 'rgb(125, 76, 236)',
  },
  version: {
    marginTop: 4,
    color: 'rgb(90, 50, 180)',
  },
  sectionCard: {
    margin: 16,
    marginTop: 8,
    elevation: 2,
    borderRadius: 12,
    borderWidth: 1,
    borderColor: 'rgba(125, 76, 236, 0.3)',
  },
  paragraph: {
    marginBottom: 12,
    fontSize: 14,
    lineHeight: 20,
    textAlign: 'justify',
    flexWrap: 'wrap',
  },
  featureTitle: {
    fontWeight: 'bold',
    marginTop: 16,
    marginBottom: 8,
  },
  divider: {
    marginLeft: 54,
    backgroundColor: 'rgba(125, 76, 236, 0.3)',
    height: 1,
  },
  lastCard: {
    marginBottom: 24,
  },
  footer: {
    alignItems: 'center',
    paddingVertical: 16,
  },
  footerText: {
    fontSize: 12,
    color: 'rgb(90, 50, 180)',
    textAlign: 'center',
  },
});

export default AboutScreen;
